(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-carousel"]) return;
  try {
    
  $(document).ready(function(){
    $('.slider').slick({
      dots: false,
      infinite: true,
      speed: 800,
      fade:true,
      autoplay: true,
  autoplaySpeed: 8000,
      arrows: true,
      slidesToShow: 1,
      adaptiveHeight: true,
      cssEase: 'linear'
    });
  });

  } catch(e) { console.error(e); }
})();
})();
